<main class="home-estimate">
  <div class="hero-photo">
    <h1 class="bold">What's my home worth?</h1>
    <div class="search-bar">
      <app-google-place-autocomplete
        inputId="home-estimate-search"
        inputName="home-estimate-search"
        placeholder="Enter a location"
        [options]="placeOptions"
        #placesRef="googlePlaceAutocomplete"
        (onAddressChange)="handleAddressChange($event)"
        (keyupEnter)="openZestimate()">
      </app-google-place-autocomplete>
      <button type="button" (click)="openZestimate()" mat-flat-button color="accent">Estimate</button>
    </div>
  </div>

  <section class="home-estimate__intro">
    <p class="home-estimate__lede">
      Curious what buyers might pay for your home today? Start with a free estimate powered by recent
      sales data — then talk with a Gabali agent when you want a number you can list with confidence.
    </p>
    <ul class="home-estimate__highlights">
      @for (item of highlights; track item) {
        <li class="home-estimate__highlight">{{ item }}</li>
      }
    </ul>
  </section>

  <section class="home-estimate__how" aria-labelledby="how-heading">
    <header class="home-estimate__section-header">
      <h2 id="how-heading" class="home-estimate__section-title">How the Estimate Works</h2>
      <p class="home-estimate__section-intro">
        Three simple steps from address to insight. The online snapshot is a starting point — not a final list price.
      </p>
    </header>
    <ul class="home-estimate__how-list">
      @for (step of howItWorks; track step.title) {
        <li class="home-estimate__how-item">
          <span class="home-estimate__how-title">{{ step.title }}</span>
          <span class="home-estimate__how-detail">{{ step.detail }}</span>
        </li>
      }
    </ul>
  </section>

  <section class="home-estimate__faq" aria-labelledby="faq-heading">
    <header class="home-estimate__section-header">
      <h2 id="faq-heading" class="home-estimate__section-title">Frequently Asked Questions</h2>
      <p class="home-estimate__section-intro">
        Selling raises big financial questions. Here is how we help sellers think through the most common ones.
      </p>
    </header>
    <div class="home-estimate__faq-grid">
      @for (item of faqs; track item.question) {
        <article class="home-estimate__faq-card">
          <h3 class="home-estimate__faq-question">{{ item.question }}</h3>
          <p class="home-estimate__faq-answer">{{ item.answer }}</p>
        </article>
      }
    </div>
  </section>

  <section class="home-estimate__resources" aria-labelledby="resources-heading">
    <header class="home-estimate__section-header">
      <h2 id="resources-heading" class="home-estimate__section-title">Next Steps for Sellers</h2>
      <p class="home-estimate__section-intro">
        Use these tools on your own time, then loop in an agent when you are ready to prep, price, or list.
      </p>
    </header>
    <div class="home-estimate__resource-grid">
      @for (resource of resources; track resource.title) {
        <article class="home-estimate__resource-card">
          <h3 class="home-estimate__resource-title">{{ resource.title }}</h3>
          <p class="home-estimate__resource-copy">{{ resource.description }}</p>
          <a class="home-estimate__resource-link" [routerLink]="resource.link">
            {{ resource.linkLabel }}
            <span aria-hidden="true">→</span>
          </a>
        </article>
      }
    </div>
  </section>

  <section class="home-estimate__local" aria-labelledby="local-heading">
    <header class="home-estimate__section-header">
      <h2 id="local-heading" class="home-estimate__section-title">Laredo Pricing Tips</h2>
      <p class="home-estimate__section-intro">
        Local market context matters as much as the algorithm. These are the points our listing agents review with sellers.
      </p>
    </header>
    <div class="home-estimate__tips-grid">
      @for (tip of localTips; track tip.title) {
        <article class="home-estimate__tip-card">
          <h3 class="home-estimate__tip-title">{{ tip.title }}</h3>
          <p class="home-estimate__tip-copy">{{ tip.description }}</p>
        </article>
      }
    </div>
  </section>
</main>
